<template>
  <checker-offers-block :offers="checkerDisplayOffers" />
  <div @click="showcaseSort" id="sorting-btn" class="sort-title">
    <div class="sort-title-wrapper">
      <div class="icon">
        <img src="/img/sort.svg" alt="" />
      </div>
      <div class="name">
        Сортировать
      </div>
      <div :class="{ toggled: showcaseSortActive }" class="dropdown-arrow">
        <img src="/img/down-arrow.svg" alt="" />
      </div>
    </div>
  </div>
  <div class="sort-menu" id="sorting" v-show="showcaseSortActive">
    <div class="sort-menu-wrapper">

      <div @click="setSort('amountUp')" class="sort-btn">
        <div class="sort-img"><img src="/img/arrow-up.svg" alt="" /></div>
        <div class="sort-txt">По сумме (возр.)</div>
      </div>

      <div @click="setSort('amountDown')" class="sort-btn">
        <div class="sort-img"><img src="/img/arrow-down.svg" alt="" /></div>
        <div class="sort-txt">По сумме (убыв.)</div>
      </div>

      <div @click="setSort('periodUp')" class="sort-btn">
        <div class="sort-img"><img src="/img/arrow-up.svg" alt="" /></div>
        <div class="sort-txt">По сроку (возр.)</div>
      </div>

      <div @click="setSort('periodDown')" class="sort-btn">
        <div class="sort-img"><img src="/img/arrow-down.svg" alt="" /></div>
        <div class="sort-txt">По сроку (убыв.)</div>
      </div>

      <div @click="setSort('ratingDown')" class="sort-btn">
        <div class="sort-img"><img src="/img/arrow-up.svg" alt="" /></div>
        <div class="sort-txt">По рейтингу (возр.)</div>
      </div>

      <div @click="setSort('ratingUp')" class="sort-btn">
        <div class="sort-img"><img src="/img/arrow-down.svg" alt="" /></div>
        <div class="sort-txt">По рейтингу (убыв.)</div>
      </div>

    </div>
  </div>
  <div class="zaym365">
    <div class="showcase-wrapper" :class="{ 'showcase-wrapper--no-swiper': !isSwiperEnabled }">
      <div v-if="isSwiperEnabled" class="swiper-pagination" ref="pagination"></div>
      <div v-if="isSwiperEnabled" class="swiper-text__label">Листайте влево</div>
      <div class="swiper showcase-swiper" ref="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link || offer.name">
            <div class="card">

              <div class="card-top">
                <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
              </div>

              <div class="card-info">
                <div class="card-info__wrap">
                  <span>Сумма:</span><span>до {{ numberFormat(offer.amount) }} ₽</span>
                </div>
                <div class="card-info__wrap">
                  <span>Срок:</span><span>до {{ offer.period }} дней</span>
                </div>
                <div class="card-info__wrap">
                  <span>Без процентов:</span><span v-if="offer.without_percent">Да</span><span
                    v-if="!offer.without_percent">Нет</span>
                </div>
                <div class="card-info__wrap">
                  <span>Рейтинг</span><span class="rating"><star-rating :max="5" :current="offer.rating"></star-rating></span>
                </div>
              </div>

              <div class="card-btn" @click="openLinks(offer)">
                <button type="button">ПОЛУЧИТЬ ЗАЕМ</button>
              </div>
            </div>
          </div>
        </div>

        <button v-if="isSwiperEnabled" class="showcase-nav prev" ref="prevBtn" :class="{ hidden: !hasMovedFromFirst }">‹</button>
        <button v-if="isSwiperEnabled" class="showcase-nav next" ref="nextBtn">›</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import * as Data from "../assets/js/data_params.js";
import StarRating from "@/components/StarRating";
import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
import CheckerOffersBlock from "./CheckerOffersBlock.vue";

export default {
  name: "Showcase365zaym",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: { StarRating, CheckerOffersBlock },

  props: {
    offers: Array,
    checkerOffers: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      ratingText: Data.getRatingText(),
      buttonText: Data.getButtonText(),
      showcaseSortActive: false,
      currentSort: null, // <-- выбранный тип сортировки
    };
  },

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return this.getCheckerDisplayOffers();
    },

    // возвращает отсортированные офферы,

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },

    sortedOffers() {
      if (!this.showcaseOffers) return [];

      const items = [...this.showcaseOffers];

      switch (this.currentSort) {
        case "amountUp":
          return items.sort((a, b) => a.amount - b.amount);
        case "amountDown":
          return items.sort((a, b) => b.amount - a.amount);
        case "periodUp":
          return items.sort((a, b) => a.period - b.period);
        case "periodDown":
          return items.sort((a, b) => b.period - a.period);
        case "ratingUp":
          return items.sort((a, b) => b.rating - a.rating);
        case "ratingDown":
          return items.sort((a, b) => a.rating - b.rating);
        default:
          return items;
      }
    },
  },

  methods: {
    showcaseSort(e) {
      e.stopPropagation();
      this.showcaseSortActive = !this.showcaseSortActive;
    },

    setSort(type) {
      this.currentSort = type;
      this.showcaseSortActive = false; // закрыть меню после выбора
    },

    numberFormat(num) {
      return Functions.numberFormat(num);
    },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      offer.links?.forEach((link) => {
        window.open(link, "_blank");
      });
    },

  },
};
</script>

<style lang="css">
@import url(../assets/css/365zaym.scss);
</style>
<style lang="css">
.sort-title {
  border-radius: 50px;
  background: #fff;
  padding: 6px 18px;
  cursor: pointer;
  width: 160px;
  position: relative;
}

.sort-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dropdown-arrow,
.name {
  margin-left: 5px;
}

.name {
  color: #3e3d3d;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.showcase-sort-btn {
  margin-left: 5px;
}

.sort-menu {
  border-radius: 10px;
  background: #f3f3f3;
  padding: 13px 18px;
  max-width: 160px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 45px;
  z-index: 2;
}

.sort-menu-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sort-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.sort-btn:not(:last-child) {
  margin-bottom: 15px;
}

.sort-txt {
  color: #3e3d3d;

  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  margin-left: 5px;
}
.dropdown-arrow img {
  transition: transform 0.3s ease;
}

/* Когда меню открыто */
.dropdown-arrow.toggled img {
  transform: rotate(180deg);
}

.swiper-text__label {
  display: none;
}

@media (max-width: 768px) {
  .swiper-text__label {
    display: block;
    font-weight: 400;
    font-size: 16px;
  }

  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

@media (min-width: 768px) {
  .showcase-wrapper > .swiper-pagination,
  .showcase-nav {
    display: none !important;
  }

  .zaym365 .showcase-wrapper--no-swiper .showcase-swiper {
    overflow: visible;
  }

  .zaym365 .showcase-wrapper--no-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    width: 100%;
  }

  .zaym365 .showcase-wrapper--no-swiper .swiper-slide {
    flex: 0 0 248px;
    max-width: 248px;
    display: flex;
  }

  .zaym365 .showcase-wrapper--no-swiper .card {
    width: 100%;
    max-width: 248px;
  }
}

@media (max-width: 767px) {
  .zaym365 .showcase-wrapper {
    display: block;
    padding: 0 0 20px;
  }

  .zaym365 .showcase-wrapper--no-swiper {
    padding: 0;
  }

  .zaym365 .showcase-wrapper--no-swiper .showcase-swiper {
    overflow: visible;
  }

  .zaym365 .showcase-wrapper--no-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    width: 100%;
    transform: none !important;
  }

  .zaym365 .showcase-wrapper--no-swiper .swiper-slide {
    flex: 0 0 248px;
    max-width: 248px;
    display: flex;
    justify-content: center;
  }

  .zaym365 .showcase-wrapper--no-swiper .card {
    max-width: 248px;
    width: 100%;
  }

  .zaym365 .showcase-wrapper > .swiper-pagination {
    display: block;
    position: relative;
    max-width: 248px;
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .zaym365 .showcase-wrapper > .swiper-pagination .swiper-pagination-progressbar-fill {
    background: linear-gradient(90deg, #1193a7, #31bb38);
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .showcase-swiper {
    overflow: visible;
    position: relative;
  }

  .zaym365 .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .zaym365 .swiper-slide .card {
    max-width: 248px;
    width: 100%;
  }

  .zaym365 .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #fff;
    background: linear-gradient(90deg, #1193a7, #31bb38);
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .showcase-nav.prev {
    left: 0px;
  }

  .showcase-nav.next {
    right: 0px;
  }
}

@media (max-width: 430px) {
  .zaym365 .showcase-wrapper--no-swiper .card {
    max-width: 248px !important;
    width: 100% !important;
  }
}

</style>
